export default __webpack_public_path__ + "static/media/countersunk-screws.dd43e645.svg";